<template>
  <div>
    <base-material-card color="secondary" icon="mdi-calendar-multiple-check" :title="$t('event_list')">
      <v-layout justify-center style="flex-wrap: wrap">
        <v-radio-group row justify-center v-model="filter" @change="loadTable()">
          <v-radio :label="$t('active_m_p')" value="active"></v-radio>
          <v-radio :label="$t('all_m_p')" value="all"></v-radio>
        </v-radio-group>
        <v-btn small @click="createEvento" color="primary">{{
          $t("create_event")
        }}</v-btn>
      </v-layout>
      <DataTables @editEvento="editEvento" @viewEvento="viewEvento" @iscriviEvento="iscriviEvento"
        @copyEvento="copyEvento" @massiveUpgradeEvento="massiveUpgradeEvento" @iscrittiEvento="iscrittiEvento"
        @stampaTicket="stampaTicket" @stampaListaPartecipanti="stampaListaPartecipanti"
        @csvListaPartecipanti="csvListaPartecipanti" :headers="headers" :tableData="tableData"></DataTables>
    </base-material-card>

    <edit-evento ref="editEventoDialog" @isUpdated="loadTable"></edit-evento>
    <iscrizione-evento ref="iscrizioneEventoDialog"></iscrizione-evento>
    <iscritti-evento ref="iscrittiEventoDialog"></iscritti-evento>
    <massive-upgrade-evento ref="massiveUpgradeEventoDialog"></massive-upgrade-evento>
  </div>
</template>

<script>
import gestEvento from "@/app/eventi/gestEvento.vue";
import iscrittiEvento from "@/app/eventi/iscrittiEvento.vue";
import iscrizioneEvento from "@/app/eventi/iscrizioneEvento.vue";
import massiveUpgradeEvento from "@/app/eventi/massiveUpgradeEvento.vue";
import listOrdini from "@/widget/listOrdini.vue";
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";

export default {
  name: "list-eventi",
  components: {
    DataTables,
    "edit-evento": gestEvento,
    "iscritti-evento": iscrittiEvento,
    "iscrizione-evento": iscrizioneEvento,
    "massive-upgrade-evento": massiveUpgradeEvento,
  },
  data() {
    return {
      filter: "active",
      headers: [
        { text: this.$t("image"), value: "image", type: "image" },
        { text: this.$t("title"), value: "titolo" },
        { text: this.$t("active_m_s"), value: "iconActive", type: "icons" },
        {
          text: this.$t("show_in_asd"),
          value: "iconShowInAsd",
          type: "icons",
        },
        {
          text: this.$t("can_buy_with_credits"),
          value: "iconBuyWithCredits",
          type: "icons",
        },
        { text: this.$t("competition"), value: "iconGara", type: "icons" },
        { text: this.$t("type"), value: "type" },
        { text: this.$t("date_inz"), value: "dateInz", type: "date" },
        { text: this.$t("date_end"), value: "dateEnd", type: "date" },
        { text: this.$t("location"), value: "locationName" },
        {
          text: this.$t("occupation_%"),
          value: "occupation",
          type: "progressBar",
        },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      tableData: [],
    };
  },

  methods: {
    emitUpdated: function (data) {
      this.loadTable();
    },
    stampaListaPartecipanti(item) {
      let url = "/auth/eventi/pdf/listaPartecipanti/" + item.idEvento;
      window.open(this.authorizeLink(url));
    },
    csvListaPartecipanti(item) {
      let url = "/auth/eventi/csv/listaPartecipanti/" + item.idEvento;
      window.open(this.authorizeLink(url));
    },
    stampaTicket(item) {
      let url = "/auth/eventi/pdf/getTicketEstrazione/" + item.idEvento;
      window.open(this.authorizeLink(url));
    },
    viewEvento(item) {
      this.$refs.editEventoDialog.open("VIEW", item.idEvento);
    },
    iscrittiEvento(item) {
      this.$refs.iscrittiEventoDialog.open(item.idEvento);
    },
    iscriviEvento(item) {
      this.$refs.iscrizioneEventoDialog.open(item.idEvento);
    },
    createEvento() {
      this.$refs.editEventoDialog.open("ADD", null);
    },
    editEvento(item) {
      this.$refs.editEventoDialog.open("EDIT", item.idEvento);
    },
    massiveUpgradeEvento(item) {
      this.$refs.massiveUpgradeEventoDialog.open(item.idEvento);
    },
    copyEvento(item) {
      if (screen.width > 648) this.$refs.editEventoDialog.open("ADD", item.idEvento);
      else
        this.$router.push(
          "/portal/eventi/gestEvento/ADD/" + item.idEvento
        );
    },
    loadTable() {
      let _ = this;
      let now = new Date();
      let url = "/auth/eventi/listEventi";
      if (_.filter === "all") url += "/all";
      _.tableData = [];
      _.isFetching = true;
      this.chiamataAxios("GET", url).then((response) => {
        // Aggiunge actions e icona validazione
        _.tableData = response.data.eventi.map(function (item) {
          if (item.attivo === 1) {
            if (new Date(item.dateEnd) >= now){
               item.iconActive = [{ icon: "mdi-check", color: "green" }];
            }
            else {
              item.iconActive = [{ icon: "mdi-close", color: "red" }];
            }
          } 
          else item.iconActive = [{ icon: "mdi-close", color: "red" }];

          item.occupation = { value: 0, label: "" };
          if (item.showInAsd === 1)
            item.iconShowInAsd = [{ icon: "mdi-check", color: "green" }];
          if (item.buyWithCredits === 1)
            item.iconBuyWithCredits = [{ icon: "mdi-check", color: "green" }];
          if (item.infoEvento) {
            if (item.infoEvento.gara) {
              item.iconGara = [{ icon: "mdi-trophy-outline", color: "green" }];
            }

            item.occupation.label =
              item.infoEvento.postiTotali -
              item.infoEvento.postiLiberi +
              " / " +
              item.infoEvento.postiTotali;
            item.occupation.value =
              (item.infoEvento.postiOccupati * 100) /
              item.infoEvento.postiTotali;
          }

          item.options = [
            {
              icon: "mdi-calendar-check",
              color: "warning",
              text: _.$t("event_booking"),
              function: "iscriviEvento",
            },
            {
              icon: "mdi-magnify",
              color: "success",
              text: _.$t("view_event"),
              function: "viewEvento",
            },
            {
              icon: "mdi-pencil",
              color: "primary",
              text: _.$t("edit_event"),
              function: "editEvento",
            },
            {
              icon: "mdi-content-copy",
              color: "primary",
              text: _.$t("copy_event"),
              function: "copyEvento",
            },
            {
              icon: "mdi-arrow-up-circle",
              color: "warning",
              text: _.$t("massive_event_upgrade"),
              function: "massiveUpgradeEvento",
            },
            {
              icon: "mdi-account-group",
              color: "success",
              text: _.$t("event_subscriber"),
              function: "iscrittiEvento",
            },
            {
              icon: "mdi-ticket",
              color: "success",
              text: _.$t("print_ticket_event"),
              function: "stampaTicket",
            },
            {
              icon: "mdi-clipboard-list-outline",
              color: "success",
              text: _.$t("print_subscriber_list_event"),
              function: "stampaListaPartecipanti",
            },
            {
              icon: "mdi-file-delimited-outline",
              color: "success",
              text: _.$t("csv_subscriber_list_event"),
              function: "csvListaPartecipanti",
            },
          ];
          return item;
        });
        _.isFetching = false;
      });
    },
  },
  mounted() {
    this.loadTable();
  },
};
</script>